import {useEffect} from "react";
import {useLexicalComposerContext} from "@lexical/react/LexicalComposerContext";
import {ArticleFileManager} from "../../../../../articles/helpers/article-file-manager";
import {$getRoot, $createParagraphNode} from "lexical";

interface Props {
    value: string | null;
}

export default function FormSyncPlugin({value}: Props) {
    const [editor] = useLexicalComposerContext();

    useEffect(() => {
        editor.update(() => {
            if (!value) {
                // Jeśli wartość jest null/undefined, wyczyść editor używając Lexical API
                const root = $getRoot();
                root.clear();
                root.append($createParagraphNode());
                return;
            }
            
            try {
                const newState = editor.parseEditorState(value);
                const current = editor.getEditorState();
                if (newState.toJSON().root !== current.toJSON().root) {
                    editor.setEditorState(newState);

                    ArticleFileManager.syncUsedFilesFromContent(value);
                }
            } catch (err) {
                console.warn("⚠️ Nie udało się sparsować stanu edytora:", err);
            }
        });
    }, [editor, value]);

    return null;
}
